// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var React = require("react");
var Atom_Text = require("../atom/Atom_Text.bs.js");
var Atom_Column = require("../atom/Atom_Column.bs.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Particle_Screen_Ds = require("../particle/Particle_Screen_Ds.bs.js");
var Particle_Background_Ds = require("../particle/Particle_Background_Ds.bs.js");
var Molecule_BurgerMenuIcon_Ds = require("./Molecule_BurgerMenuIcon_Ds.bs.js");
var Molecule_BurgerMenuIcon_Css = require("./Molecule_BurgerMenuIcon_Css.bs.js");
var Organism_HeaderAccessibility = require("../organism/header/Organism_HeaderAccessibility.bs.js");

function Molecule_BurgerMenuIcon(Props) {
  var state = Props.state;
  var toggle = Props.toggle;
  var style = Props.style;
  var display = Props.display;
  var view = Molecule_BurgerMenuIcon_Ds.view(style);
  var match = Molecule_BurgerMenuIcon_Css.toCss(view);
  var __x = state ? [] : match.transform;
  var transformClass = CssJs.style(__x);
  var className = CssJs.merge([
        CssJs.style(match.line),
        transformClass
      ]);
  var background = state ? Particle_Background_Ds.transparent : view.background;
  var accessibility = Organism_HeaderAccessibility.accessibility(state);
  var tmp = {
    accessibility: accessibility,
    alignItems: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "stretch"),
    background: background,
    blockSpace: view.blockSpace,
    children: null,
    height: view.height,
    kind: {
      TAG: /* Button */1,
      _0: "button",
      _1: toggle,
      _2: undefined
    },
    rules: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, match.wrapper),
    width: view.width
  };
  if (display !== undefined) {
    tmp.display = Caml_option.valFromOption(display);
  }
  return React.createElement(Atom_Column.make, tmp, React.createElement("span", {
                  className: className
                }), React.createElement("span", {
                  className: className
                }), React.createElement(Atom_Text.ScreenreadersLabel.make, {
                  children: "Menu"
                }));
}

var make = Molecule_BurgerMenuIcon;

exports.make = make;
/* CssJs Not a pure module */
